/**
 * Provides constants used in the tracking of business acquisition
 * from a number of outside campaigns.
 */
const BusinessAcquisitionTrackingConstants = {
  // Google AdWords
  GOOGLE_ADWORDS_ID: 852082959,
  GOOGLE_ADWORDS_LABEL_PROPEL_QUALIFIED: 'Mah3CPrv13YQj4KnlgM',
  GOOGLE_ADWORDS_LABEL_PROPEL_UNQUALIFIED: '_DJfCKzy13YQj4KnlgM',
  GOOGLE_ADWORDS_LABEL_BUSINESS_CREATE: 'GGbCCM7p-nYQj4KnlgM',
  GOOGLE_ADWORDS_LABEL_BUSINESS_CONVERT: 'SwBsCIz9k3cQj4KnlgM',
  GOOGLE_ADWORDS_LABEL_BUSINESS_ADVERTISER_INTENT: 'kDf0COWL4okBEI-Cp5YD',

  // DoubleClick
  DOUBLECLICK_TAG_ID: '8032161',
  DOUBLECLICK_EVENT_ID_PROPEL: 'prope001',
  DOUBLECLICK_CATEGORY_ID_PROPEL_QUALIFIED: 'pinte0',
  DOUBLECLICK_CATEGORY_ID_PROPEL_UNQUALIFIED: 'pinte00',

  // The Trade Desk
  TRADEDESK_ADVERTISER_ID: 'fc1uc9n',
  TRADEDESK_EVENT_ID_GENERAL_PAGEVIEW: 'ogalyt3',
  TRADEDESK_CONVERSION_ID_PROPEL_QUALIFIED: 'judrn76',
  TRADEDESK_CONVERSION_ID_PROPEL_UNQUALIFIED: 'f0v4s5d',

  // Facebook
  FACEBOOK_ADVERTISER_ID: '956400731086791',

  // Twitter
  TWITTER_UNIVERSAL_TAG_ID: 'nuzh8',
  TWITTER_CONVERSION_ID_PROPEL_QUALIFIED: 'ny8zl',
  TWITTER_CONVERSION_ID_PROPEL_UNQUALIFIED: 'nya0d',

  // LinkedIn
  LINKEDIN_PARTNER_ID: '44352',
  LINKEDIN_CONVERSION_ID_PROPEL_QUALIFIED: '166217',
  LINKEDIN_CONVERSION_ID_PROPEL_UNQUALIFIED: '171754',
  LINKEDIN_CONVERSION_ID_SUBMISSION_EVENT: '529092',

  // Pinterest
  PINTEREST_TAG_ID: '2614461171935',
  SMB_PAID_PINTEREST_ID: '2613736141997',
};

export default BusinessAcquisitionTrackingConstants;
